import { computed } from 'vue';
import { useScreen } from 'vue-screen';
import { defineStore } from '@/store/store';

const useGlobalStore = defineStore('global', () => {
    const screen = useScreen();
    const screenSize = computed(() => ({
        width: Math.min(screen.width, 1024),
        height: screen.height,
    }));
    const isMobile = computed(() => screen.width <= 860);
    return {
        isMobile,
        screenSize,
    };
});
export const GlobalStore = useGlobalStore();
